import setSweepRuleUIUpdate from './setSweepRuleUIUpdate';
import setSweepRuleService from '../services/setSweepRuleService';
import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import store from '../store/store';
/**
 * Saves the current sweep rule configuration
 */
export default action('setSweepRule', datapoints.setSweepRule)(function setSweepRule(sweepRuleId, sweepOperation) {
    // store information about the sweep rule to operate on, if the request fails we need to revert the UI
    var ruleIdIndex = store.sweepRuleIds.indexOf(sweepRuleId);
    var rule = store.sweepRules.get(sweepRuleId);
    setSweepRuleUIUpdate(sweepRuleId, sweepOperation);
    return setSweepRuleService(sweepRuleId, sweepOperation)
        .then(function (response) {
        if (response.Body.ResponseMessages.Items[0].ResponseClass != 'Success') {
            // revert UI on failure
            revertSweepRuleUI(sweepOperation, rule, sweepRuleId, ruleIdIndex);
        }
    })
        .catch(function (error) {
        // revert UI on failure
        revertSweepRuleUI(sweepOperation, rule, sweepRuleId, ruleIdIndex);
    });
});
function revertSweepRuleUI(sweepOperation, rule, ruleId, ruleIdIndex) {
    if (sweepOperation == 1 /* Delete */) {
        store.sweepRules.set(ruleId, rule);
        store.sweepRuleIds.splice(ruleIdIndex, 0, ruleId);
    }
    else {
        // other sweep rule operations are enable/disable
        rule.IsEnabled = !rule.IsEnabled;
    }
}
//# sourceMappingURL=setSweepRule.js.map